import React, { useEffect, useRef, useState, useSyncExternalStore } from "react";
import "./CuteLoader.css";

export const SAYINGS = [
  "Sorry, like… I'm still trying to load.",
  "Hold on, doing my lashes.",
  "One sec, setting my brows.",
  "Applying a second coat…",
  "Babe, I'm almost ready.",
  "Fluffing your numbers…",
  "Still curing. Don't touch.",
  "Counting your coins, hang on.",
  "Just one more swipe of mascara.",
];
const MIN_MS = 400;
const GOODBYE_MS = 1600;

// Tiny shared store: keeps the loader up for its 400ms minimum after the page swaps it out,
// and shows the goodbye screen across the logout navigation.
let state = { afterUntil: 0, goodbyeUntil: 0, saying: 0 };
const listeners = new Set();
const setState = (patch) => { state = { ...state, ...patch }; listeners.forEach((l) => l()); };
const subscribe = (l) => { listeners.add(l); return () => listeners.delete(l); };
const getState = () => state;

export const showGoodbye = () => setState({ goodbyeUntil: Date.now() + GOODBYE_MS });

const randomOther = (i) => {
  let n = Math.floor(Math.random() * SAYINGS.length);
  if (n === i) n = (n + 1) % SAYINGS.length;
  return n;
};

export const CuteEye = ({ mode = "blink" }) => (
  <svg className={`cute-eye cute-eye-${mode}`} width="56" height="56" viewBox="0 0 56 56" fill="none" aria-hidden="true">
    <g className="cute-eye-lid">
      <path d="M6 30 Q28 10 50 30 Q28 48 6 30 Z" stroke="#231E1A" strokeWidth="1.6" strokeLinejoin="round" vectorEffect="non-scaling-stroke" />
      <circle cx="28" cy="30" r="6.5" stroke="#231E1A" strokeWidth="1.6" vectorEffect="non-scaling-stroke" />
      <circle cx="28" cy="30" r="2.2" fill="#231E1A" />
    </g>
    <g className="cute-eye-lashes" stroke="#231E1A" strokeWidth="1.4" strokeLinecap="round" vectorEffect="non-scaling-stroke">
      <path d="M14 22 L11 17" />
      <path d="M21 18.5 L19.5 13" />
      <path d="M28 17.5 L28 11.5" />
      <path d="M35 18.5 L36.5 13" />
      <path d="M42 22 L45 17" />
    </g>
  </svg>
);

const Sayings = ({ start }) => {
  const [i, setI] = useState(start);
  useEffect(() => {
    const t = setInterval(() => setI((cur) => { const n = randomOther(cur); setState({ saying: n }); return n; }), 2500);
    return () => clearInterval(t);
  }, []);
  return <p key={i} className="cute-loader-line" data-testid="cute-loader-line">{SAYINGS[i]}</p>;
};

const LoaderVisual = ({ start, overlay }) => (
  <div className={`cute-loader${overlay ? " cute-loader-overlay" : ""}`} role="status" aria-live="polite" data-testid="cute-loader">
    <span className="cute-sr-only">Loading</span>
    <CuteEye />
    <Sayings start={start} />
  </div>
);

export const CuteLoader = () => {
  const startRef = useRef(Date.now());
  const [start] = useState(() => { const n = randomOther(-1); state.saying = n; return n; });
  useEffect(() => () => {
    const remaining = MIN_MS - (Date.now() - startRef.current);
    if (remaining > 0) setState({ afterUntil: Date.now() + remaining });
  }, []);
  return <LoaderVisual start={start} />;
};

export const LoaderHost = () => {
  const s = useSyncExternalStore(subscribe, getState);
  const [, tick] = useState(0);
  const now = Date.now();
  const until = Math.max(s.afterUntil, s.goodbyeUntil);
  useEffect(() => {
    if (until <= Date.now()) return undefined;
    const t = setTimeout(() => tick((x) => x + 1), until - Date.now() + 10);
    return () => clearTimeout(t);
  }, [until]);
  if (s.goodbyeUntil > now) {
    return (
      <div className="cute-loader cute-loader-overlay" role="status" aria-live="polite" data-testid="goodbye-screen">
        <CuteEye mode="wink" />
        <p className="cute-goodbye-title" data-testid="goodbye-title">Biiiyeeee!</p>
        <p className="cute-loader-line" data-testid="goodbye-sub">See you next shift.</p>
      </div>
    );
  }
  if (s.afterUntil > now) return <LoaderVisual start={s.saying} overlay />;
  return null;
};
